import React, { useRef, useState } from "react";
import Divider from "@mui/material/Divider";
import { EstadoAgenteChip, FormButton, SpinnerOverlay } from "components";
import { FormikSelectInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import { ESTADOS_OPERATIVO } from "../consts";
import { RNHAgenteAsignarDo } from "services/services-mia/programa-salud/personal/RNHAgenteAsignarDo";

/**
 * Cambio de estado de UN LUGAR del agente.
 *
 * No es el estado del agente —ese es el del vínculo y se cambia desde el listado—, sino
 * el de una asignación puntual. Son dos catálogos distintos: este admite **Licencia**,
 * que para el agente no existe.
 *
 * Por debajo es una MODIFICACIÓN de lugar: id + versión + el dato que cambia. Mandar id
 * y versión sin ningún otro dato lo desasignaría, así que el estado nuevo siempre viaja.
 *
 * El estado actual no se ofrece como opción: elegirlo sería una modificación sin
 * cambios, que el back rechaza con 43036.
 */
export default function EstadoLugarModal({
  row,
  asignacion,
  updateList,
  closeModal,
}) {
  const credentials = useRecoilValue(userCredentials);
  const setSnackBarInfo = useSetRecoilState(snackbarData);
  const [inRequest, setInRequest] = useState(false);
  const formikRef = useRef();

  const estadoActual = asignacion?.statusCod ?? "";
  const opciones = ESTADOS_OPERATIVO.filter(({ cod }) => cod !== estadoActual);

  const cambiarEstado = async (values) => {
    setInRequest(true);

    const respuesta = await RNHAgenteAsignarDo(credentials, {
      agenteId: row?.id,
      lugarId: asignacion?.id,
      lugarVersion: asignacion?.version,
      lugarStatusCod: values.status,
    });
    setInRequest(false);

    if (!respuesta.ok) return;

    setSnackBarInfo({
      message: "Estado de la asignación modificado correctamente",
      severity: "success",
      open: true,
    });
    formikRef.current.resetForm();
    updateList?.();
    closeModal?.();
  };

  return (
    <Formik
      innerRef={formikRef}
      initialValues={{ status: "" }}
      validationSchema={yup.object({
        status: yup.string().required("Debe elegir un estado nuevo"),
      })}
      onSubmit={cambiarEstado}
    >
      <Form className={styles.inputs} noValidate>
        <div
          className={styles["column"]}
          style={{ width: "420px", maxWidth: "100%" }}
        >
          <div style={{ width: "100%" }}>
            <div
              style={{
                alignItems: "center",
                display: "flex",
                gap: "1rem",
                justifyContent: "space-around",
              }}
            >
              <div>
                <h3 style={{ fontSize: "1.15rem", fontWeight: 600, margin: 0 }}>
                  {asignacion?.lugar}
                </h3>
                <p
                  style={{
                    color: "#5F6368",
                    margin: "0.25rem 0 0",
                    textAlign: "center",
                  }}
                >
                  {asignacion?.funcion}
                </p>
              </div>
              <EstadoAgenteChip cod={estadoActual} />
            </div>
          </div>

          <Divider sx={{ margin: "0.25rem 0 0.75rem", width: "100%" }} />

          <FormikSelectInput fullWidth={true} name="status" labelText="Nuevo estado">
            <option value="" disabled>
              Seleccione
            </option>
            {opciones.map(({ cod, label }) => (
              <option key={cod} value={cod}>
                {label}
              </option>
            ))}
          </FormikSelectInput>

          <FormButton
            inRequest={inRequest}
            submitDisabled={asignacion?.version == null}
            newFormData={{ button: "Guardar" }}
            onCloseModal={closeModal}
          />
          {inRequest && <SpinnerOverlay />}
        </div>
      </Form>
    </Formik>
  );
}
